import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import getCurrentUid from '../utilities/getCurrentUid'

const getPostKudos = async ({ postIds }) => {
	if (!postIds) {
		throw errorOfType(errorTypes.KEYNOTSPECIFIED, 'getPostKudos')
	}
	try {
		const uid = getCurrentUid()
		const kudosDocSnaps = await Promise.all(postIds.map(async postId => firestore.collection('posts').doc(postId).collection('kudos').doc(uid).get()))
		const kudos = postIds.reduce((result, postId, i) => ({
			...result,
			[postId]: kudosDocSnaps[i].exists && kudosDocSnaps[i].data()
		}), {})

		return { kudos }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, postIds, exception)
	}
}

export default getPostKudos



// WEBPACK FOOTER //
// ./src/dataservices/getPostKudos.js